export const DEFAULT_PAGE_STYLE = {
    'background': '#ffffff',
    'width': '794px',
    'height': '1123px',
    'padding': '26px',
    'box-sizing': 'border-box',
}

export function styleZoom(
    style: { [key: string]: any },
    level: number
) {
    if (!style) return {};

    const keys = new Set([
        "top",
        "left",
        "right",
        "bottom",
        "width",
        "height",
        "padding",
        "padding-block",
        "padding-inline",
        "padding-top",
        "padding-left",
        "padding-right",
        "padding-bottom",
        "margin",
        "margin-top",
        "margin-left",
        "margin-right",
        "margin-bottom",
        "font-size",
    ]);

    const newStyle: Record<string, any> = {};

    Object.entries(style).forEach(([key, val]) => {
        if (!keys.has(key)) {
            newStyle[key] = val;
            return;
        }

        let ext = "";
        if (typeof val === "string") {
            if (val.includes("px")) ext = "px";
            else if (val.includes("%")) ext = "%";
            else if (val.includes("em")) ext = "em";
        }

        const num = parseFloat(val);
        newStyle[key] = isNaN(num) ? val : `${num * level}${ext || "px"}`;
    });

    return newStyle;
}